import { Button, Spin, Tooltip } from "antd";
import React from "react";
import { TriggerForEditor } from "../../../../../libs/types/src";
import { UseFormReturn } from "react-hook-form";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import { FormLabel } from "./FormLabel";
import { CloseCircleOutlined } from "@ant-design/icons";

/**
 * This component is used in components that are the root node of the user flow, such as TriggerRootForm.
 */
export const RootFormWithCommonParts: React.FC<{
  onSubmit: () => void;
  form: UseFormReturn<any>;
  trigger: TriggerForEditor;
}> = ({ onSubmit, form, children, trigger }) => {
  const { state, dispatch } = useTriggerEditorStateDispatch();

  const readOnly = !state.trigger.current.isDraft;
  const isPersisting = state.editor.isPersisting === "save-draft";
  const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  const onSave = async () => {
    await onSubmit();
    dispatch({ type: "unselect" });
  };

  return (
    <form className="flex flex-col gap-3 text-left" onSubmit={onSave}>
      <div className="flex justify-between">
        <FormLabel
          label={capitalize(trigger.type.replaceAll("_", " "))}
        ></FormLabel>
        <Tooltip title="Save and close" placement="bottom">
          <CloseCircleOutlined
            style={{ fontSize: "20px", color: "#6C6C6C" }}
            onClick={onSave}
          />
        </Tooltip>
      </div>

      {children}
      {!readOnly && (
        <Button
          type="primary"
          htmlType="submit"
          disabled={
            isPersisting || Object.keys(form.formState.errors).length > 0
          }
        >
          <div className="flex gap-4 justify-center w-full">
            {isPersisting && <Spin />}
            <span>Save</span>
          </div>
        </Button>
      )}
    </form>
  );
};
